import { Err, Result } from 'neverthrow'

export const isErr = <T, E>(result: Result<T, E>): result is Err<T, E> => {
  return result.isErr()
}
